import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showFeedback: true,
    scroll: 0,
    tab: 0,
    language: Cookies.get('language') || 'en'
  },
  getters: {
    language: state => state.language
  },
  mutations: {
    changeFeedback (state, bool) {
      state.showFeedback = bool
    },
    changeScroll (state, scroll) {
      state.scroll = scroll
    },
    changeTab (state, tab) {
      state.tab = tab
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
})
